"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsTitleGallery = OfferDetailsTitleGallery;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const icons_1 = require("@ant-design/icons");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const get_asset_image_source_1 = require("@src/shared/get-asset-image-source");
const elements_1 = require("@src/components/elements");
const OfferDetailsTitleGallery_style_1 = require("./OfferDetailsTitleGallery.style");
const TitleGalleryVideoAsset_1 = require("./TitleGalleryVideoAsset");
function CarouselPrevArrow({ onClick }) {
    return ((0, jsx_runtime_1.jsx)(OfferDetailsTitleGallery_style_1.CarouselArrowContainer, { position: "left", onClick: onClick, children: (0, jsx_runtime_1.jsx)(icons_1.LeftOutlined, {}) }));
}
function CarouselNextArrow({ onClick }) {
    return ((0, jsx_runtime_1.jsx)(OfferDetailsTitleGallery_style_1.CarouselArrowContainer, { position: "right", onClick: onClick, children: (0, jsx_runtime_1.jsx)(icons_1.RightOutlined, {}) }));
}
function getAssetImgUrl(asset) {
    return (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: (0, get_asset_image_source_1.getAssetImageSource)(asset),
        transformation: 'h_420,c_scale',
        shouldIncludeEnvironmentPart: false,
        addWatermarkedLogo: true,
    });
}
function OfferDetailsTitleGallery({ assets }) {
    const [currentAssetIndex, setCurrentAssetIndex] = react_1.default.useState(0);
    const [videoAssetsPlayingStatuses, setVideoAssetsPlayingStatuses] = react_1.default.useState(assets.map(asset => ({ assetId: asset.id, isPlaying: false })));
    const carouselRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        carouselRef.current.goTo(currentAssetIndex);
        const currentAsset = assets[currentAssetIndex];
        setVideoAssetsPlayingStatuses(currentPlayingStatuses => currentPlayingStatuses.map(status => status.assetId === currentAsset.id ? { ...status, isPlaying: true } : { ...status, isPlaying: false }));
    }, [currentAssetIndex]);
    const handleAfterChange = (newAssetIndex) => {
        if (currentAssetIndex !== newAssetIndex) {
            setCurrentAssetIndex(newAssetIndex);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Carousel, { dots: false, ref: carouselRef, afterChange: handleAfterChange, arrows: true, prevArrow: (0, jsx_runtime_1.jsx)(CarouselPrevArrow, {}), nextArrow: (0, jsx_runtime_1.jsx)(CarouselNextArrow, {}), children: assets.map(asset => ((0, jsx_runtime_1.jsxs)(OfferDetailsTitleGallery_style_1.AssetContainer, { children: [asset.type === types_1.AssetType.IMAGE && (0, jsx_runtime_1.jsx)(OfferDetailsTitleGallery_style_1.AssetImg, { src: getAssetImgUrl(asset) }), asset.type === types_1.AssetType.VIDEO && ((0, jsx_runtime_1.jsx)(TitleGalleryVideoAsset_1.TitleGalleryVideoAsset, { asset: asset, isPlaying: videoAssetsPlayingStatuses.find(status => status.assetId === asset.id).isPlaying }))] }, asset.id))) }), Boolean(assets.length && assets.length > 1) && ((0, jsx_runtime_1.jsx)(OfferDetailsTitleGallery_style_1.CarouselDotsContainer, { children: assets.map((asset, index) => ((0, jsx_runtime_1.jsx)(OfferDetailsTitleGallery_style_1.CarouselDot, { onClick: () => setCurrentAssetIndex(index), shouldBeHighlighted: index === currentAssetIndex }, asset.id))) }))] }));
}
